import { Divider, Form, Input, Spin, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import {
  fetchData,
  fetchFilesSecured,
} from "../../../../../features/fetch/fetchSlice";
import useModalToggle from "../../../../../custom_hooks/useModalToggle";
import DocumentAdd from "./DocumentAdd";
import ConfirmModal from "../../../../../components/ConfirmModal";
import Search from "../../../../../components/Search";
import { formatImgPath } from "../../../../../utils";
import CardLoading from "../../../../../components/CardLoading";
import svg46 from "../../../../../assets/svg/svg46.svg";
import svg45 from "../../../../../assets/svg/svg45.svg";

function DocImages({ handleNext, handleBack }) {
  const { open, handleCancel, handleOpen } = useModalToggle();
  const url = "sch/get_scheme_files";
  const { saving } = useSelector((state) => state.save);
  const { loading, data, count, activeObjSchemes } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    activeObjSchemes: state.obj.activeObj["schemes"],
  }));
  const { refetchKey } = useSelector((state) => state.global);
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        schId: activeObjSchemes?.schId,
        schfType: "SPATIAL_IMAGES",
        schfName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [prodd1, setProdd1] = useState();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = async (item) => {
    await setProdd(item);
    await setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "sch/delete_scheme_files",
        schfId: prodd?.schfId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleAdd = async () => {
    await handleOpen();
  };
  const handlePrev = () => {
    handleBack();
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        projectId: activeObjSchemes?.projectId,
        url: "api/v2/main_projects/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleNext();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFilesSecured({ file: item }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        schfType: "SPATIAL_IMAGES",
        schId: activeObjSchemes?.schId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 2) {
      fetchTableData();
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <div className="flex  flex-col gap-[1.25rem]  min-h-[45vh]">
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between lg:mt-[.25rem] gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
          <div className="w-[50px]">
            <button
              onClick={handleAdd}
              className="cstm-btn-2 !rounded-[1.5625rem]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clip-path="url(#clip0_6842_21395)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.83333 0.999349C6.83333 0.539111 6.46023 0.166016 6 0.166016C5.53976 0.166016 5.16666 0.539111 5.16666 0.999349V5.16602H0.999997C0.53976 5.16602 0.166664 5.53912 0.166664 5.99935C0.166664 6.45958 0.53976 6.83268 0.999997 6.83268H5.16666V10.9993C5.16666 11.4596 5.53976 11.8327 6 11.8327C6.46023 11.8327 6.83333 11.4596 6.83333 10.9993V6.83268H11C11.4602 6.83268 11.8333 6.45958 11.8333 5.99935C11.8333 5.53912 11.4602 5.16602 11 5.16602H6.83333V0.999349Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_6842_21395">
                    <rect
                      width="11.6667"
                      height="11.6667"
                      fill="white"
                      transform="translate(0.166664 0.166016)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </div>

        <div className="custom-title  mt-[1rem]">Uploaded Images</div>
        <div className="flex items-center flex-shrink flex-wrap gap-[1.25rem]">
          {data &&
            data?.map((item) => (
              <div className="flex flex-col w-[15rem]">
                <img
                  loading="lazy"
                  className="w-full h-[10rem]"
                  src={formatImgPath(item?.schfFile)}
                  alt={item?.schfName}
                />

                <div className="flex items-center justify-between w-full border border-[#E3E5E5] rounded-t-[0.25rem] p-[.5rem] text-[#090A0A] text-[.75rem] font-[400] font-interSans">
                  <span className=" truncate max-w-full overflow-hidden whitespace-nowrap">
                    {item?.schfName}
                  </span>

                  <div
                    className="flex items-center gap-x-[.62rem]"
                    onClick={() => setProdd(item)}
                  >
                    <img
                      src={svg45}
                      alt="svg45"
                      className="cursor-pointer"
                      onClick={() => downloadFile(item?.schfFile)}
                    />
                    <img
                      className="cursor-pointer"
                      src={svg46}
                      alt="svg46"
                      onClick={() => handleOpenDelete()}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <DocumentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
        prodd1={prodd1}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </>
  );
}

export default DocImages;
